'use client'

import ValidateInput from 'member/components/Common/Validate/ValidateInput/ValidateInput'

export default ValidateInput
